module.exports = __webpack_public_path__ + "img/home_type_italian.6b6e6612.webp";